var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showAddAdjustment
    ? _c(
        "div",
        { staticClass: "rtb-bs m-0 p-10 p-t-20" },
        [
          _c(
            "div",
            { staticClass: "add-adjustment-filter-inputs slide-down m-t-0" },
            [
              _vm.showComparisonTag(_vm.adjustment)
                ? _c(
                    "div",
                    { staticClass: "add-adjustment-tag-input-group" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.adjustmentTagToInput,
                            expression: "adjustmentTagToInput"
                          }
                        ],
                        staticClass:
                          "form-control filter-criteria-value add-adjustment-tag-input",
                        attrs: {
                          "data-cy": "input-adjustment-tag-name",
                          placeholder: _vm.$t("INPUT_TAG"),
                          type: "text"
                        },
                        domProps: { value: _vm.adjustmentTagToInput },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) return
                              _vm.adjustmentTagToInput = $event.target.value
                            },
                            _vm.onTagSelected
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("RtbMacrosPopover", {
                        on: { "selected-macro": _vm.onSelectedMacro }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("SearchableDropdown", {
                staticClass:
                  "filter-comparison-type add-adjustment-comparison-type",
                attrs: {
                  "data-cy": "select-adjustment-comparison-type",
                  rules: "required",
                  config: _vm.comparisonOptions,
                  placeholder: _vm.$t("ROUTER_TAG_COMPARE_PH"),
                  searchable: false,
                  clearable: false
                },
                on: { change: _vm.onAdjustmentComparisonType },
                model: {
                  value: _vm.adjustmentComparisonType,
                  callback: function($$v) {
                    _vm.adjustmentComparisonType = $$v
                  },
                  expression: "adjustmentComparisonType"
                }
              }),
              _vm._v(" "),
              !_vm.allowMultiselect &&
              !_vm.inputIsRange &&
              !_vm.isBoolean &&
              !_vm.autoFillFilterValues
                ? _c(
                    "ValidationProvider",
                    {
                      attrs: {
                        rules: _vm.adjustmentComparisonValueValidations,
                        slim: ""
                      }
                    },
                    [
                      _vm.showComparisonValue(_vm.adjustment)
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.adjustmentComparisonValue,
                                expression: "adjustmentComparisonValue"
                              }
                            ],
                            staticClass:
                              "form-control filter-criteria-value add-adjustment-comparison-input",
                            attrs: {
                              "data-cy": "input-adjustment-comparison-value",
                              placeholder: _vm.$t("ROUTER_TAG_VALUE_PH"),
                              type: "text"
                            },
                            domProps: { value: _vm.adjustmentComparisonValue },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.adjustmentComparisonValue =
                                  $event.target.value
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showBulkSelector(_vm.adjustment)
                ? _c("BulkModifiersSelector", {
                    staticClass: "add-adjustment-comparison-input",
                    attrs: {
                      "selected-bulk-modifier-id":
                        _vm.currentAdjustment.bulkListId
                    },
                    on: { selected: _vm.onSelectedBulkModifier }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.allowMultiselect && !_vm.inputIsRange
                ? _c(
                    "ValidationProvider",
                    { attrs: { rules: "required", slim: "" } },
                    [
                      _vm.showComparisonValue(_vm.adjustment)
                        ? _c("MultiSelect", {
                            staticClass:
                              "add-adjustment-filter-or-criteria__value multi-select-lg add-adjustment-comparison-input",
                            class: { "multi-select-lg": _vm.isFullWidth },
                            attrs: {
                              "show-select-all": "",
                              "list-items": _vm.prefilledValuesForTag
                            },
                            model: {
                              value: _vm.adjustmentComparisonValue,
                              callback: function($$v) {
                                _vm.adjustmentComparisonValue = $$v
                              },
                              expression: "adjustmentComparisonValue"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.adjustment.comparisonTypeTemp.value != "REQUIRED"
                ? _c("SearchableDropdown", {
                    staticClass:
                      "filter-comparison-type add-adjustment-operation-type",
                    attrs: {
                      "data-cy": "select-adjustment-operation-type",
                      rules: "required",
                      config: _vm.operationOptions,
                      placeholder: _vm.$t("ROUTER_TAG_COMPARE_PH"),
                      searchable: false,
                      clearable: false
                    },
                    on: { change: _vm.onAdjustmentOperationType },
                    model: {
                      value: _vm.adjustmentOperationType,
                      callback: function($$v) {
                        _vm.adjustmentOperationType = $$v
                      },
                      expression: "adjustmentOperationType"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              (_vm.isOperationInputActive ? "number" : "text") === "checkbox" &&
              _vm.showOperationValue(_vm.adjustment)
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.adjustmentOperationValue,
                        expression: "adjustmentOperationValue"
                      }
                    ],
                    staticClass:
                      "form-control filter-criteria-value add-adjustment-operation-input",
                    attrs: {
                      "data-cy": "input-adjustment-value",
                      placeholder: _vm.$t("ROUTER_OPERATION_VALUE_PH"),
                      type: "checkbox"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.adjustmentOperationValue)
                        ? _vm._i(_vm.adjustmentOperationValue, null) > -1
                        : _vm.adjustmentOperationValue
                    },
                    on: {
                      focus: function($event) {
                        _vm.isOperationInputActive = true
                      },
                      blur: function($event) {
                        _vm.isOperationInputActive = false
                      },
                      change: function($event) {
                        var $$a = _vm.adjustmentOperationValue,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.adjustmentOperationValue = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.adjustmentOperationValue = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.adjustmentOperationValue = $$c
                        }
                      }
                    }
                  })
                : (_vm.isOperationInputActive ? "number" : "text") ===
                    "radio" && _vm.showOperationValue(_vm.adjustment)
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.adjustmentOperationValue,
                        expression: "adjustmentOperationValue"
                      }
                    ],
                    staticClass:
                      "form-control filter-criteria-value add-adjustment-operation-input",
                    attrs: {
                      "data-cy": "input-adjustment-value",
                      placeholder: _vm.$t("ROUTER_OPERATION_VALUE_PH"),
                      type: "radio"
                    },
                    domProps: {
                      checked: _vm._q(_vm.adjustmentOperationValue, null)
                    },
                    on: {
                      focus: function($event) {
                        _vm.isOperationInputActive = true
                      },
                      blur: function($event) {
                        _vm.isOperationInputActive = false
                      },
                      change: function($event) {
                        _vm.adjustmentOperationValue = null
                      }
                    }
                  })
                : _vm.showOperationValue(_vm.adjustment)
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.adjustmentOperationValue,
                        expression: "adjustmentOperationValue"
                      }
                    ],
                    staticClass:
                      "form-control filter-criteria-value add-adjustment-operation-input",
                    attrs: {
                      "data-cy": "input-adjustment-value",
                      placeholder: _vm.$t("ROUTER_OPERATION_VALUE_PH"),
                      type: _vm.isOperationInputActive ? "number" : "text"
                    },
                    domProps: { value: _vm.adjustmentOperationValue },
                    on: {
                      focus: function($event) {
                        _vm.isOperationInputActive = true
                      },
                      blur: function($event) {
                        _vm.isOperationInputActive = false
                      },
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.adjustmentOperationValue = $event.target.value
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showOperationOverrideFromTag(_vm.adjustment)
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.overrideTag,
                        expression: "overrideTag"
                      }
                    ],
                    staticClass:
                      "form-control filter-criteria-value add-adjustment-operation-input",
                    attrs: {
                      placeholder: _vm.$t("OPERATION_OVERRIDE_FROM_TAG_PH"),
                      type: "text"
                    },
                    domProps: { value: _vm.overrideTag },
                    on: {
                      focus: function($event) {
                        _vm.isOperationInputActive = true
                      },
                      blur: function($event) {
                        _vm.isOperationInputActive = false
                      },
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.overrideTag = $event.target.value
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("Field", {
            attrs: { label: "", "hide-label": false },
            scopedSlots: _vm._u(
              [
                {
                  key: "element",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "btns-add-adjustment" }, [
                        _c("button", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: _vm.editAdjustment ? "UPDATE" : "ADD",
                              expression: "editAdjustment ? 'UPDATE' : 'ADD'"
                            }
                          ],
                          staticClass:
                            "btn btn-primary add-adjustment-btn btn-xs m-t-5",
                          attrs: {
                            disabled: !_vm.isAdjustmentValid(),
                            "data-cy": "btn-save-adjustment",
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              _vm.editAdjustment
                                ? _vm.onEditAdjustment(_vm.currentRow)
                                : _vm.onAddAdjustment()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("button", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CANCEL",
                              expression: "'CANCEL'"
                            }
                          ],
                          staticClass:
                            "btn btn-danger btn-xs add-adjustment-btn m-l-10 m-t-5",
                          attrs: { type: "button" },
                          on: { click: _vm.onCancelAddAdjustment }
                        })
                      ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1424132757
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }